import {
    Formik,
    FormikProps
} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {
    Account,
    AccountFormType,
    AccountRecordFormProps,
    AccountStatus,
    AccountType
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: AccountRecordFormProps) => {

    // FNP-555: async and RETURNS the promise, so Formik holds isSubmitting
    // until the mutation settles. A synchronous onSubmit cleared it on the
    // same tick, which left the submit button live and double-submit open.
    const onSubmit = async (values: AccountFormType) => {
        await handleSubmit(values as Account);
    };

    let initialValues = {
        accountType: AccountType.STANDALONE,
        accountStatus: AccountStatus.ACTIVE,
    } as Account;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik<AccountFormType>
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<AccountFormType>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
